// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".survey[data-v-18cadcd4]{display:flex;flex-direction:column;height:100%}@media (max-width:768px){.content[data-v-18cadcd4]{font-size:1rem;margin:10px 0}}@media (min-width:768px){.content[data-v-18cadcd4]{font-size:1.5rem;margin:60px 0 10px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
